import React from 'react';
import {
  Box,
  Stack,
  Menu,
  Typography,
  IconButton
} from '@mui/material';
import { getTranslation } from '../common';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { ProcessModelType } from '../model/processModel';
import { Task } from '../model/activitiesModel';
import ActivityFilter from './activity/ActivityFilter';
import { Translations } from '../model/messageModel';
import MultiSelectSearch from './MultiSelectSearch';

interface MyActivitiesFilterMenuProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  translations: Translations;
  handleClearFilters: (disableLocalStorage?: boolean, clearUserData?: boolean) => void;
  processModels: ProcessModelType[];
  selectedModels: number[];
  setSelectedModels: (models: number[]) => void;
  tasks: { todo: Task[], doing: Task[] };
  uniqueActivities: string[];
  selectedActivities: string[];
  setSelectedActivities: (activities: string[]) => void;
  userDataKeys: string[];
  selectedUserDataKey: string | null;
  handleSelectUserDataKey: (key: string | null) => void;
}

const MyActivitiesFilterMenu: React.FC<MyActivitiesFilterMenuProps> = ({
  open,
  anchorEl,
  onClose,
  translations,
  handleClearFilters,
  processModels,
  selectedModels,
  setSelectedModels,
  tasks,
  uniqueActivities,
  selectedActivities,
  setSelectedActivities,
  userDataKeys,
  selectedUserDataKey,
  handleSelectUserDataKey,
}) => {
  const availableProcessModels = processModels.filter((model) =>
    tasks.todo
      .concat(tasks.doing)
      .some((task) => task.idprocessmodel === model.id)
  );

  return (
    <Menu
      id="filter-popover"
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <Box p={2} sx={{ overflowX: "hidden" }}>
        <Stack direction="column" spacing={2}>
          <Box display="flex" alignItems="center" justifyContent="space-between" minWidth={200}>
            <Typography variant="subtitle1" fontWeight="bold">
              {getTranslation(translations, "generic.filters.caption")}
            </Typography>
            <IconButton color="primary" onClick={() => handleClearFilters()} size="small">
              <FilterListOffIcon />
            </IconButton>
          </Box>
          <Box minWidth={200}>
            {processModels.length > 0 && (
              <Typography
                variant="subtitle1"
                gutterBottom
                fontWeight="bold"
              >
                {getTranslation(
                  translations,
                  "generic.filter.by.processmodel"
                )}
              </Typography>
            )}
            <MultiSelectSearch
              options={availableProcessModels.map((model) => ({
                value: String(model.id),
                label: model.name,
              }))}
              selected={selectedModels.map(String)}
              onChange={(models) => setSelectedModels(models.map(Number))}
              label={getTranslation(
                translations,
                "generic.filter.by.processmodel"
              )}
            />
          </Box>
          <Box minWidth={200}>
            <Typography
              variant="subtitle1"
              gutterBottom
              fontWeight="bold"
            >
              {getTranslation(
                translations,
                "generic.filter.by.activity"
              )}
            </Typography>
            <ActivityFilter
              selectedActivities={selectedActivities}
              onActivityChange={setSelectedActivities}
              options={uniqueActivities}
            />
          </Box>
        </Stack>
      </Box>
    </Menu>
  );
};

export default MyActivitiesFilterMenu;
